import React from 'react';
import './industries.css';
import { useTheme } from '../../components/context/ThemeContext';
import ContactRequest from '../../components/contact_request/ContactRequest';
import PublicWorks from './components/PublicWorks';
import Telecom from './components/Telecom';
import Utilities from './components/Utilities';
import DisasterResponse from './components/DisasterResponse';
import Forestry from './components/Forestry';
import Mining from './components/Mining';
import Construction from './components/Construction';

const Industries = () => {
    const { theme } = useTheme();
    
    return (
        <div className={`industries-container ${theme}`}>
            <div className="industries-header">
                <h1>Industry Solutions</h1>
                <p>Advanced LiDAR technology tailored for your industry's unique challenges</p>
                <div className="top-cta">
                    <ContactRequest />
                </div>
            </div>
            
            <PublicWorks />
            <Telecom />
            <Utilities />
            <Construction />
            <DisasterResponse />
            <Mining />
            <Forestry />
            
            <div className="bottom-cta">
                <h2>Ready to Apply LiDAR to Your Industry?</h2>
                <p>Our team of experts can help you implement custom LiDAR solutions specific to your industry needs.</p>
                <ContactRequest />
            </div>
        </div>
    );
};

export default Industries;
